import axios from "axios";
import "bootstrap-css-only/css/bootstrap.min.css";
import "core-js";
import { find, get } from "lodash";
import React, { Fragment, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Redirect, Route, Router, Switch } from "react-router-dom";
import "~/api/axios.config";
import "~/assets/scss/mdb.scss";
import Button from "~/components/common/atoms/Button";
import ScrollToTop from "~/components/common/atoms/ScrollToTop";
import GetContent from "~/components/common/molecules/GetContent";
import { ToastNotification } from "~/components/common/molecules/ToastNotification";
import Breadcrumb from "~/components/desktop/atoms/Breadcrumb";
import StickyNotification from "~/components/desktop/molecules/StickyNotification";
import Footer from "~/components/desktop/organisms/Footer";
import Header from "~/components/desktop/organisms/Header";
import styles from "~/components/desktop/templates/AuthTemplate/style.module.scss";
import NavBar from "~/components/mobile/atoms/NavBar";
import { partnerInfo } from "~/configs/partnerDetails";
import history from "~/history";
import AuthenticationMedpro from "~/router_hospitals/AuthenticationMedpro";
import { listAppId, ROUTE_WITHOUT_HEADER } from "~/utils/constants";
import listRouters from "~/utils/listRouter";
import AppId from "~/utils/partner";
import { scrollToTop } from "~/utils/tool";
import { store } from "./store";
import "./store/checkVersion";
import { useLegacyTokenMigrator } from "~/hooks/useLegacyTokenMigrator";

import { client } from "./utils/medproSDK";
import { BrowserRouter } from "react-router-dom/cjs/react-router-dom.min";

const favicon = document.getElementById("favicon");
favicon.href = `./favicon/${AppId}.png`;

// dynamic title web
const info = get(partnerInfo, "info");
const nameInfo = find(info, { key: "name" });
document.getElementById(
  "title-page"
).textContent = `${nameInfo.value} | Phần mềm đăng ký khám bệnh Online`;

class Root extends React.Component {
  constructor(props) {
    super(props);
    axios.defaults.headers.appid = AppId;
    axios.defaults.headers.partnerid = AppId;
  }

  state = {
    isOpen: false
  };

  headerScrollRef = React.createRef();
  socialSupportRef = React.createRef();

  onhandleToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  handleTop = () => {
    scrollToTop(700);
  };

  async componentDidMount() {
    const currentState = store.getState();
    const typeDv = currentState.global.device.type;
    client.setPlatform(typeDv === "desktop" ? "pc" : "web");

    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    if (!!this.headerScrollRef.current && !!this.socialSupportRef.current) {
      if (window.pageYOffset > 150 && window.innerWidth > 992) {
        this.headerScrollRef.current.style.display = "block";
        this.socialSupportRef.current.style.display = "block";
      } else {
        this.headerScrollRef.current.style.display = "none";
        this.socialSupportRef.current.style.display = "none";
      }
    }
  };

  render() {
    window.history.scrollRestoration = "manual";

    return (
      <BrowserRouter>
        <Router history={history}>
          <Route
            render={({ location }) => {
              const pathname = location.pathname;
              const mainPathname = pathname.split("/")[1];
              // Các route kh chứa header
              const routeWithoutHeader = !ROUTE_WITHOUT_HEADER.includes(
                `/${mainPathname}`
              );
              return (
                <React.Fragment>
                  <div className={styles.wrapper_template}>
                    {routeWithoutHeader &&
                    !pathname.includes("-app") &&
                    !pathname.includes("/in-phieu-kham-cskh") &&
                    !pathname.includes("/cham-soc-khach-hang") ? (
                      <Fragment>
                        <Header handleToggle={this.onhandleToggle} />
                        <NavBar
                          hideLeft
                          rightContent={[
                            <Button
                              column="column"
                              menu="menu"
                              icon={<i className="fal fa-bars" />}
                              key={1}
                            >
                              Menu
                            </Button>
                          ]}
                        />
                      </Fragment>
                    ) : (
                      <StickyNotification />
                    )}

                    <div className={styles.wrapper_content}>
                      <Switch location={location}>
                        {listRouters.map(item => {
                          if (item.childDynamic) {
                            return item.childDynamic.map(itemChild => {
                              if (itemChild.path !== "/login") {
                                return (
                                  <Route
                                    key={itemChild.id}
                                    path={
                                      listAppId.includes(AppId)
                                        ? `${item.path}${itemChild.path}`
                                        : itemChild.path
                                    }
                                    exact
                                    render={props => (
                                      <AuthenticationMedpro
                                        ChildComponent={itemChild.component}
                                        isMigrating={this.props.isMigrating}
                                        {...props}
                                        {...itemChild}
                                      />
                                    )}
                                  />
                                );
                              } else {
                                return (
                                  <Route
                                    key={itemChild.id}
                                    path={
                                      listAppId.includes(AppId)
                                        ? `${item.path}${itemChild.path}`
                                        : itemChild.path
                                    }
                                    exact
                                    render={props => (
                                      <>
                                        {itemChild.breadcrumb && (
                                          <Breadcrumb className="head" />
                                        )}
                                        <itemChild.component {...props} />
                                      </>
                                    )}
                                  />
                                );
                              }
                            });
                          } else {
                            if (item.path !== "/login") {
                              return (
                                <Route
                                  key={item.id}
                                  path={item.path}
                                  exact
                                  render={props => (
                                    <AuthenticationMedpro
                                      ChildComponent={item.component}
                                      isMigrating={this.props.isMigrating}
                                      {...props}
                                      {...item}
                                    />
                                  )}
                                />
                              );
                            } else {
                              return (
                                <Route
                                  key={item.id}
                                  path={item.path}
                                  exact
                                  render={props => (
                                    <>
                                      {item.breadcrumb && (
                                        <Breadcrumb className="head" />
                                      )}
                                      <item.component {...props} />
                                    </>
                                  )}
                                />
                              );
                            }
                          }
                        })}

                        <Route
                          render={() => <Redirect to={{ pathname: "/" }} />}
                        />
                      </Switch>
                      <ScrollToTop />
                    </div>
                  </div>

                  {!pathname.includes("medicalDetailByUser") &&
                  !pathname.includes("-app") &&
                  !pathname.includes("/in-phieu-kham-cskh") &&
                  !pathname.includes("/cham-soc-khach-hang") &&
                  !pathname.includes("/login") &&
                  pathname.indexOf("in-phieu-kham-benh") === -1 ? (
                    <Fragment>
                      <Footer />
                    </Fragment>
                  ) : null}
                </React.Fragment>
              );
            }}
          />
        </Router>
        <ToastNotification />
        <GetContent />
      </BrowserRouter>
    );
  }
}

const ConnectedRoot = connect()(Root);

const AuthListener = () => {
  useEffect(() => {
    const handleLogoutEvent = () => {
      history.push("/login");
    };

    window.addEventListener("unauthorized-logout", handleLogoutEvent);
    return () => {
      window.removeEventListener("unauthorized-logout", handleLogoutEvent);
    };
  }, []);
  return null;
};

const AnythingLLMChatWidget = () => {
  const isAuthenticated = useSelector(state => state.user.IsAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) return;

    // 1. Inject custom styles for AnythingLLM SVG
    const style = document.createElement("style");
    style.id = "anything-llm-embed-chat-button";
    style.innerHTML = `
      .anything-llm-embed-chat-button svg,
      #anything-llm-embed-chat-button svg {
        margin: 0 !important;
      }
    `;
    document.head.appendChild(style);

    // 2. Inject AnythingLLM Script
    const script = document.createElement("script");
    script.src =
      "https://anythingllm.medpro.com.vn/embed/anythingllm-chat-widget.min.js";
    script.setAttribute(
      "data-embed-id",
      "07fe4442-7f08-4af6-a6c7-9ded35e6e400"
    );
    script.setAttribute(
      "data-base-api-url",
      "https://anythingllm.medpro.com.vn/api/embed"
    );
    script.setAttribute("data-chat-icon", "chatBubble");
    script.setAttribute("data-assistant-name", `Trợ lý AI CSKH`);
    script.setAttribute(
      "data-send-message-text",
      "Nhập câu hỏi của bạn tại đây..."
    );
    script.setAttribute("data-no-sponsor", "true");
    script.setAttribute(
      "data-brand-image-url",
      `https://bo-api.medpro.com.vn:5000/static/images/medpro/app/image/mpicon.png`
    );
    // script.setAttribute("data-no-header", "true");
    script.setAttribute("data-greeting", "Hãy gửi tin nhắn để bắt đầu.");
    script.async = true;
    document.body.appendChild(script);

    // 3. Clean up script, style, and generated DOM components on logout
    return () => {
      style.remove();
      script.remove();

      const elementsToClean = [
        "anythingllm-chat-widget-container",
        "anythingllm-chat-widget-bubble",
        "anythingllm-chat-widget-wrapper"
      ];
      elementsToClean.forEach(id => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });

      const extraWidget = document.querySelector(
        'iframe[id^="anything-ll-m"], iframe[id^="anything-llm"]'
      );
      if (extraWidget) extraWidget.remove();

      if (window.anythingllm) {
        delete window.anythingllm;
      }
    };
  }, [isAuthenticated]);

  return null;
};

function RootWrapper(props) {
  const { isMigrating } = useLegacyTokenMigrator();

  return (
    <>
      <AuthListener />
      <AnythingLLMChatWidget />
      {isMigrating ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh"
          }}
        >
          <div className="spinner-border text-primary" role="status" />
        </div>
      ) : (
        <ConnectedRoot isMigrating={isMigrating} {...props} />
      )}
    </>
  );
}

export default RootWrapper;
